import { render, staticRenderFns } from "./sso.vue?vue&type=template&id=89195c6a&scoped=true"
import script from "./sso.vue?vue&type=script&lang=js"
export * from "./sso.vue?vue&type=script&lang=js"
import style0 from "./sso.vue?vue&type=style&index=0&id=89195c6a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89195c6a",
  null
  
)

export default component.exports